module.exports = __webpack_public_path__ + "img/8.21a879ec.jpg";